import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createVNode as _createVNode, isRef as _isRef, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "p-5 border-b border-gray-200 flex justify-between gap-4" }
const _hoisted_2 = { class: "text-sm text-gray-600" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col items-center justify-center gap-3 px-5 py-16 text-gray-600"
}
const _hoisted_4 = { class: "px-5 py-4 border-b border-gray-200 space-y-3" }
const _hoisted_5 = {
  key: 0,
  class: "rounded-lg border border-red-200 bg-red-50 px-3 py-2 space-y-2"
}
const _hoisted_6 = { class: "text-xs text-red-700" }
const _hoisted_7 = { class: "flex flex-wrap gap-2" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "grid grid-cols-1 md:grid-cols-3 gap-3" }
const _hoisted_10 = {
  key: 1,
  class: "text-xs text-gray-500"
}
const _hoisted_11 = { class: "p-5 grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_12 = {
  key: 0,
  class: "text-xs text-amber-700 mt-1"
}
const _hoisted_13 = {
  key: 0,
  class: "text-xs text-gray-500 mt-1"
}
const _hoisted_14 = {
  key: 1,
  class: "text-xs text-gray-500 mt-1"
}
const _hoisted_15 = {
  key: 0,
  class: "text-xs text-gray-500 mt-1"
}
const _hoisted_16 = { class: "md:col-span-2" }
const _hoisted_17 = {
  key: 0,
  class: "mt-2 text-xs text-gray-600"
}
const _hoisted_18 = {
  key: 0,
  class: "block text-amber-700 mt-1"
}
const _hoisted_19 = {
  key: 1,
  class: "block text-amber-700 mt-1"
}
const _hoisted_20 = { class: "md:col-span-2" }
const _hoisted_21 = {
  key: 0,
  class: "mt-3 space-y-2"
}
const _hoisted_22 = { class: "text-xs text-red-700" }
const _hoisted_23 = { class: "text-sm font-semibold text-red-700" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 1,
  class: "mt-3 space-y-2"
}
const _hoisted_26 = { class: "text-sm font-semibold text-red-700" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 2,
  class: "mt-2 p-3 bg-blue-50 border-l-4 border-blue-500 rounded-r"
}
const _hoisted_29 = {
  key: 0,
  class: "text-sm text-blue-700"
}
const _hoisted_30 = {
  key: 1,
  class: "text-sm text-red-600"
}
const _hoisted_31 = {
  key: 2,
  class: "text-xs text-blue-600"
}
const _hoisted_32 = {
  key: 2,
  class: "md:col-span-2 space-y-3"
}
const _hoisted_33 = { class: "flex items-center gap-2 flex-shrink-0 w-28" }
const _hoisted_34 = { class: "text-sm font-medium text-black truncate" }
const _hoisted_35 = { class: "flex flex-wrap gap-2" }
const _hoisted_36 = { class: "text-xs text-gray-600" }
const _hoisted_37 = ["value", "onInput"]
const _hoisted_38 = {
  key: 3,
  class: "md:col-span-2 space-y-3"
}
const _hoisted_39 = { class: "text-sm font-medium text-black w-28 truncate" }
const _hoisted_40 = ["value", "onInput"]
const _hoisted_41 = { class: "px-5 py-4 border-b border-gray-200" }
const _hoisted_42 = { class: "p-5 border-t border-gray-200 space-y-3" }
const _hoisted_43 = {
  key: 0,
  class: "text-sm text-red-600"
}
const _hoisted_44 = { class: "flex justify-end gap-2" }
const _hoisted_45 = { class: "text-sm text-gray-600" }
const _hoisted_46 = { class: "font-medium text-black" }
const _hoisted_47 = { class: "flex justify-end" }

import { computed, ref, watch } from "vue";
import BaseInput from "@/components/forms/BaseInput.vue";
import CategoryTreeAutocomplete from "@/components/forms/CategoryTreeAutocomplete.vue";
import ShopifyMelPhotosEditor from "@/components/shopify/ShopifyMelPhotosEditor.vue";
import CouleursSelector from "@/components/mel/CouleursSelector.vue";
import CouleursPickerModal from "@/components/mel/CouleursPickerModal.vue";
import CompositionForm from "@/components/mel/CompositionForm.vue";
import ActionButton from "@/components/ui/ActionButton.vue";
import { useShopifyMelProductSheet } from "@/composables/useShopifyMelProductSheet";
import type { CouleurAPI } from "@/types/mel-components";
import type { CategoryPathSelection } from "@/types/categorie";
import type { ShopifyCatalogPage, ShopifyProduct } from "@/types/shopify";


export default /*@__PURE__*/_defineComponent({
  __name: 'ShopifyMelProductSheet',
  props: /*@__PURE__*/_mergeModels({
    modelValue: {},
    reloadCatalog: { type: Function }
  }, {
    "catalog": { required: true },
    "catalogModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["update:modelValue", "saved", "error", "success"], ["update:catalog"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;

const catalog = _useModel<ShopifyCatalogPage>(__props, "catalog");

const emit = __emit;

const sheet = useShopifyMelProductSheet({
  catalog,
  onReloadCatalog: async () => {
    await props.reloadCatalog();
    emit("saved");
  },
  success: (message) => emit("success", message),
  error: (message) => emit("error", message),
});

const {
  editedProduct,
  savingProduct,
  openingProduct,
  productImageOverrides,
  categoriesTree,
  selectedColors,
  pendingColors,
  colorCollisions,
  colorSourceChoices,
  collisionChoiceLabel,
  assignCollisionColor,
  pendingCategories,
  hasEfashionCategorySelection,
  selectedCompositions,
  compositionType,
  compositionLocations,
  shoeCompositions,
  compositionAutocompleteOptions,
  showCompositionDropdown,
  isLoadingCompositionAutocomplete,
  selectedCategoryLevel1,
  selectedCategoryLevel2,
  selectedCategoryLevel3,
  productShopifyPriceHint,
  productWholesalePriceHint,
  productShopifyWeightHint,
  form,
  brandOptions,
  collectionOptions,
  provenanceOptions,
  packOptions,
  sizeRangeOptions,
  categoryLevel1Options,
  categoryLevel2Options,
  categoryLevel3Options,
  selectedSizeNames,
  soldByOptions,
  melangeesPackMismatchMessage,
  productFormMissingFields,
  canSaveProductForm,
  officialColors,
  linkedSourceLabelsByColorId,
  openProduct,
  closeProduct,
  saveProduct,
  linkPendingColor,
  linkPendingCategory,
  onCategoryPathSelect,
  onCategoryLevel1Change,
  onCategoryLevel2Change,
  onCategoryLevel3Change,
  onCategoryPathClear,
  handleCompositionInput,
  selectComposition,
  hideCompositionDropdown,
  onProductImagesUpdate,
  onProductImagesSaved,
  setTailleStockQuantity,
  setColorStock,
} = sheet;

function collisionLabelKey(value: string) {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase("fr")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

const linkedLabelsWithoutCollisions = computed(() => {
  const blocked = new Set(
    colorCollisions.value.flatMap((group) =>
      group.names.map((name) => collisionLabelKey(name)),
    ),
  );
  const next: Record<number, string[]> = {};
  for (const [id, labels] of Object.entries(linkedSourceLabelsByColorId.value)) {
    const kept = labels.filter(
      (label) => !blocked.has(collisionLabelKey(label)),
    );
    if (kept.length) next[Number(id)] = kept;
  }
  return next;
});

const collisionPickerSelectedIds = computed(() => {
  const name = collisionColorToAssign.value;
  if (!name) return [];
  const key = collisionLabelKey(name);
  const choice = colorSourceChoices.value.find(
    (item) => collisionLabelKey(item.sourceName) === key,
  );
  return choice ? [choice.colorId] : [];
});

const collisionDisabledColorIds = computed(() => {
  const name = collisionColorToAssign.value;
  if (!name) return [];
  const key = collisionLabelKey(name);
  const current = colorSourceChoices.value.find(
    (item) => collisionLabelKey(item.sourceName) === key,
  );
  const collisionIds = new Set(
    colorCollisions.value.map((group) => group.colorId),
  );
  const takenByAnotherName = new Set(
    colorSourceChoices.value
      .filter((item) => collisionLabelKey(item.sourceName) !== key)
      .map((item) => item.colorId),
  );
  const disabled = new Set<number>();
  for (const colorId of takenByAnotherName) disabled.add(colorId);
  for (const color of selectedColors.value) {
    const colorId = Number(color.id);
    if (current && colorId === current.colorId) continue;
    if (collisionIds.has(colorId) && !takenByAnotherName.has(colorId)) continue;
    disabled.add(colorId);
  }
  return [...disabled];
});

const pendingColorModalVisible = ref(false);
const pendingColorToLink = ref<string | null>(null);
const collisionColorToAssign = ref<string | null>(null);
const pendingCategoryModalVisible = ref(false);
const pendingCategoryToLink = ref<string | null>(null);

function openPendingColorPicker(sourceLabel: string) {
  collisionColorToAssign.value = null;
  pendingColorToLink.value = sourceLabel;
  pendingColorModalVisible.value = true;
}

function openCollisionColorPicker(sourceLabel: string) {
  pendingColorToLink.value = null;
  collisionColorToAssign.value = sourceLabel;
  pendingColorModalVisible.value = true;
}

function openPendingCategoryPicker(sourceLabel: string) {
  pendingCategoryToLink.value = sourceLabel;
  pendingCategoryModalVisible.value = true;
}

async function onPendingColorConfirm(colors: CouleurAPI[]) {
  const collisionLabel = collisionColorToAssign.value;
  const sourceLabel = pendingColorToLink.value;
  const official = colors[0];
  pendingColorModalVisible.value = false;
  pendingColorToLink.value = null;
  collisionColorToAssign.value = null;
  if (!official) return;
  if (collisionLabel) {
    assignCollisionColor(collisionLabel, official);
    return;
  }
  if (!sourceLabel) return;
  await linkPendingColor(sourceLabel, official);
}

async function onPendingCategorySelect(path: CategoryPathSelection) {
  const sourceLabel = pendingCategoryToLink.value;
  pendingCategoryModalVisible.value = false;
  pendingCategoryToLink.value = null;
  if (!sourceLabel) return;
  await linkPendingCategory(sourceLabel, path);
}

function formatPrice(value: number) {
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
  }).format(value);
}

function formatWeight(value: number) {
  return `${value.toLocaleString("fr-FR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  })} kg`;
}

function emitError(message: string) {
  emit("error", message);
}

watch(
  () => props.modelValue,
  (product) => {
    if (product && product.id !== editedProduct.value?.id) {
      void openProduct(product);
    }
    if (!product && editedProduct.value) {
      closeProduct();
    }
  },
  { immediate: true },
);

watch(editedProduct, (product) => {
  if (product?.id !== props.modelValue?.id) {
    emit("update:modelValue", product);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.modelValue)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 z-[9998] flex items-center justify-center p-3 overflow-hidden overscroll-none",
            onClick: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"])),
            onWheel: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["prevent"])),
            onTouchmove: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("button", {
              class: "absolute inset-0 bg-black/50",
              "aria-label": "Fermer",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(closeProduct) && _unref(closeProduct)(...args)), ["stop"]))
            }),
            _createElementVNode("form", {
              class: "relative bg-white rounded-xl shadow-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto",
              onSubmit: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["prevent"])),
              onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"])),
              onWheel: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"])),
              onTouchmove: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", null, [
                  _cache[28] || (_cache[28] = _createElementVNode("h2", { class: "text-lg font-semibold text-black" }, " Compléter la fiche MEL ", -1)),
                  _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.modelValue.reference) + " · " + _toDisplayString(_ctx.modelValue.name), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "text-gray-500",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(closeProduct) && _unref(closeProduct)(...args)))
                }, _cache[29] || (_cache[29] = [
                  _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                ]))
              ]),
              (_unref(openingProduct))
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[30] || (_cache[30] = [
                    _createElementVNode("i", { class: "fas fa-spinner fa-spin text-2xl text-blue-600" }, null, -1),
                    _createElementVNode("p", { class: "text-sm font-medium text-black" }, " Chargement des photos par couleur… ", -1),
                    _createElementVNode("p", { class: "text-xs text-gray-500 text-center max-w-sm" }, " La fiche s’affiche dès que le détail Shopify est prêt. ", -1)
                  ])))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_4, [
                      _cache[33] || (_cache[33] = _createElementVNode("p", { class: "text-sm font-semibold text-black" }, "Catégorie eFashion", -1)),
                      (_unref(pendingCategories).length && !_unref(hasEfashionCategorySelection))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _cache[32] || (_cache[32] = _createElementVNode("p", { class: "text-sm font-medium text-red-800" }, " Catégorie Shopify ", -1)),
                            _createElementVNode("p", _hoisted_6, " Vous pouvez lier « " + _toDisplayString(_unref(pendingCategories)[0]) + " » à une catégorie eFashion (réutilisé ensuite), ou choisir directement une catégorie ci-dessous ", 1),
                            _createElementVNode("div", _hoisted_7, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pendingCategories), (pending) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: pending,
                                  type: "button",
                                  class: "inline-flex items-center gap-1.5 rounded-md border border-red-300 bg-white px-2.5 py-1 text-xs font-medium text-red-700 hover:bg-red-100",
                                  onClick: ($event: any) => (openPendingCategoryPicker(pending))
                                }, [
                                  _cache[31] || (_cache[31] = _createElementVNode("i", { class: "fas fa-link text-[10px]" }, null, -1)),
                                  _createTextVNode(" Lier : " + _toDisplayString(pending), 1)
                                ], 8, _hoisted_8))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(CategoryTreeAutocomplete, {
                        tree: _unref(categoriesTree),
                        "cat-id": _unref(selectedCategoryLevel1),
                        "sous-id": _unref(selectedCategoryLevel2),
                        "sous-sous-id": _unref(selectedCategoryLevel3),
                        label: "Recherche rapide catégorie",
                        placeholder: "Rechercher une catégorie (ex. robe, jean…)",
                        onSelect: _unref(onCategoryPathSelect),
                        onClear: _unref(onCategoryPathClear)
                      }, null, 8, ["tree", "cat-id", "sous-id", "sous-sous-id", "onSelect", "onClear"]),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(BaseInput, {
                          modelValue: _unref(selectedCategoryLevel1),
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(selectedCategoryLevel1) ? (selectedCategoryLevel1).value = $event : null)),
                          type: "select",
                          "open-on-focus": "",
                          label: "Catégorie",
                          options: _unref(categoryLevel1Options),
                          placeholder: "Choisir une catégorie",
                          required: "",
                          onChange: _unref(onCategoryLevel1Change)
                        }, null, 8, ["modelValue", "options", "onChange"]),
                        _createVNode(BaseInput, {
                          modelValue: _unref(selectedCategoryLevel2),
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(selectedCategoryLevel2) ? (selectedCategoryLevel2).value = $event : null)),
                          type: "select",
                          "open-on-focus": "",
                          label: "Sous-catégorie",
                          options: _unref(categoryLevel2Options),
                          placeholder: "Choisir une sous-catégorie",
                          disabled: !_unref(selectedCategoryLevel1),
                          required: "",
                          onChange: _unref(onCategoryLevel2Change)
                        }, null, 8, ["modelValue", "options", "disabled", "onChange"]),
                        _createVNode(BaseInput, {
                          modelValue: _unref(selectedCategoryLevel3),
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(selectedCategoryLevel3) ? (selectedCategoryLevel3).value = $event : null)),
                          type: "select",
                          "open-on-focus": "",
                          label: "Sous-sous-catégorie",
                          options: _unref(categoryLevel3Options),
                          placeholder: "Choisir une ss-catégorie",
                          disabled: 
                !_unref(selectedCategoryLevel2) || !_unref(categoryLevel3Options).length
              ,
                          onChange: _unref(onCategoryLevel3Change)
                        }, null, 8, ["modelValue", "options", "disabled", "onChange"])
                      ]),
                      (_ctx.modelValue?.productType || _ctx.modelValue?.shopifyCategoryName)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Type produit Shopify : " + _toDisplayString(_ctx.modelValue.productType || _ctx.modelValue.shopifyCategoryName), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", null, [
                        _createVNode(BaseInput, {
                          modelValue: _unref(form).brandId,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).brandId) = $event)),
                          type: "select",
                          "open-on-focus": "",
                          label: "Marque",
                          options: _unref(brandOptions),
                          placeholder: "Choisir une marque",
                          required: _unref(brandOptions).length > 1
                        }, null, 8, ["modelValue", "options", "required"]),
                        (_unref(editedProduct)?.pendingBrands?.length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_12, " Marque Shopify « " + _toDisplayString(_unref(editedProduct).pendingBrands[0]) + " » à lier dans Configuration Shopify, ou choisissez une marque pour cette fiche. ", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(BaseInput, {
                        modelValue: _unref(form).collectionId,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).collectionId) = $event)),
                        type: "select",
                        "open-on-focus": "",
                        label: "Collection",
                        options: _unref(collectionOptions),
                        placeholder: "Toutes les saisons",
                        required: ""
                      }, null, 8, ["modelValue", "options"]),
                      _createElementVNode("div", null, [
                        _createVNode(BaseInput, {
                          modelValue: _unref(form).provenanceId,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).provenanceId) = $event)),
                          type: "select",
                          "open-on-focus": "",
                          label: "Provenance",
                          options: _unref(provenanceOptions),
                          placeholder: "Choisir un pays",
                          required: ""
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(BaseInput, {
                          modelValue: _unref(form).price,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).price) = $event)),
                          type: "number",
                          label: "Prix HT",
                          step: "0.01",
                          min: "0",
                          placeholder: "0.00",
                          required: ""
                        }, null, 8, ["modelValue"]),
                        _cache[34] || (_cache[34] = _createElementVNode("p", { class: "text-xs text-amber-700 mt-1" }, " Les prix Shopify sont souvent des prix B2C. Vérifiez le prix grossiste HT eFashion avant la mise en ligne. ", -1)),
                        (_unref(productShopifyPriceHint))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_13, " Prix Shopify d'origine : " + _toDisplayString(formatPrice(_unref(productShopifyPriceHint))), 1))
                          : _createCommentVNode("", true),
                        (_unref(productWholesalePriceHint))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_14, " Prix grossiste détecté : " + _toDisplayString(formatPrice(_unref(productWholesalePriceHint))), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(BaseInput, {
                          modelValue: _unref(form).weight,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).weight) = $event)),
                          type: "number",
                          label: "Poids unitaire (kg)",
                          step: "0.001",
                          min: "0.001",
                          max: 5,
                          placeholder: "0.000",
                          required: ""
                        }, null, 8, ["modelValue"]),
                        _cache[35] || (_cache[35] = _createElementVNode("p", { class: "text-xs text-red-600 mt-0.5" }, " Merci de bien vouloir augmenter légèrement le poids pour prendre en compte les cintres, cartons ou surplus d'emballage. Maximum 5 kg. ", -1)),
                        (_unref(productShopifyWeightHint))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_15, " Poids Shopify d'origine : " + _toDisplayString(formatWeight(_unref(productShopifyWeightHint))), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(CompositionForm, {
                          modelValue: _unref(selectedCompositions),
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(selectedCompositions) ? (selectedCompositions).value = $event : null)),
                          "composition-type": _unref(compositionType),
                          localisations: _unref(compositionLocations),
                          "compositions-list": _unref(shoeCompositions),
                          "autocomplete-options": _unref(compositionAutocompleteOptions),
                          "show-autocomplete-dropdown": _unref(showCompositionDropdown),
                          "is-loading-autocomplete": _unref(isLoadingCompositionAutocomplete),
                          onCompositionInput: _unref(handleCompositionInput),
                          onHideDropdown: _unref(hideCompositionDropdown),
                          onSelectAutocomplete: _unref(selectComposition)
                        }, null, 8, ["modelValue", "composition-type", "localisations", "compositions-list", "autocomplete-options", "show-autocomplete-dropdown", "is-loading-autocomplete", "onCompositionInput", "onHideDropdown", "onSelectAutocomplete"]),
                        (_unref(editedProduct)?.compositionLabel)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                              _createTextVNode(" Composition Shopify : " + _toDisplayString(_unref(editedProduct).compositionLabel) + " ", 1),
                              (_unref(editedProduct).pendingCompositions?.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, " Matières à valider dans Configuration Shopify : " + _toDisplayString(_unref(editedProduct).pendingCompositions.join(", ")), 1))
                                : _createCommentVNode("", true),
                              (_unref(editedProduct).compositionNeedsReview)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, " Composition Shopify à vérifier : format ou total des pourcentages invalide. "))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(BaseInput, {
                        modelValue: _unref(form).soldBy,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(form).soldBy) = $event)),
                        type: "select",
                        "open-on-focus": "",
                        label: "Vendu par",
                        options: _unref(soldByOptions),
                        placeholder: "Tailles",
                        required: ""
                      }, null, 8, ["modelValue", "options"]),
                      _cache[40] || (_cache[40] = _createElementVNode("p", { class: "md:col-span-2 -mt-2 text-xs text-gray-500" }, " Par défaut : Tailles. Modifiable si besoin (Couleurs / Couleurs mélangées). ", -1)),
                      _createVNode(BaseInput, {
                        modelValue: _unref(form).sizeRangeId,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(form).sizeRangeId) = $event)),
                        type: "select",
                        "open-on-focus": "",
                        label: "Taille du paquet",
                        options: _unref(sizeRangeOptions),
                        placeholder: "Choisir une déclinaison",
                        required: ""
                      }, null, 8, ["modelValue", "options"]),
                      (_unref(form).soldBy && _unref(form).soldBy !== 'tailles')
                        ? (_openBlock(), _createBlock(BaseInput, {
                            key: 0,
                            modelValue: _unref(form).packId,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(form).packId) = $event)),
                            type: "select",
                            "open-on-focus": "",
                            label: "Quantité du paquet",
                            options: _unref(packOptions),
                            placeholder: "Choisir un pack",
                            required: ""
                          }, null, 8, ["modelValue", "options"]))
                        : _createCommentVNode("", true),
                      (_unref(form).soldBy === 'melangees' && _unref(form).sizeRangeId)
                        ? (_openBlock(), _createBlock(BaseInput, {
                            key: 1,
                            modelValue: _unref(form).stock,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(form).stock) = $event)),
                            type: "number",
                            label: "Stock en paquet (optionnel)",
                            min: "0",
                            placeholder: "0"
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(CouleursSelector, {
                          modelValue: _unref(selectedColors),
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_isRef(selectedColors) ? (selectedColors).value = $event : null)),
                          "couleurs-list": _unref(officialColors),
                          "linked-source-labels-by-color-id": linkedLabelsWithoutCollisions.value,
                          "tailles-list": 
                _unref(form).soldBy === 'melangees' ? _unref(selectedSizeNames) : undefined
              
                        }, null, 8, ["modelValue", "couleurs-list", "linked-source-labels-by-color-id", "tailles-list"]),
                        (_unref(colorCollisions).length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _cache[36] || (_cache[36] = _createElementVNode("p", { class: "text-sm font-medium text-red-700" }, " Plusieurs couleurs Shopify sont liées à la même couleur officielle ", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(colorCollisions), (group) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: group.colorId,
                                  class: "space-y-2"
                                }, [
                                  _createElementVNode("p", _hoisted_22, " Liées à " + _toDisplayString(group.officialLabel), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.names, (name) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: `${group.colorId}-${name}`,
                                      class: "flex flex-wrap items-center gap-2 rounded-md border border-red-200 bg-red-50 px-3 py-2"
                                    }, [
                                      _createElementVNode("span", _hoisted_23, _toDisplayString(name), 1),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "text-sm text-red-700 underline hover:text-red-900",
                                        onClick: ($event: any) => (openCollisionColorPicker(name))
                                      }, _toDisplayString(_unref(collisionChoiceLabel)(name)
                        ? `Liée à ${_unref(collisionChoiceLabel)(name)} pour cette fiche`
                        : "Choisir une couleur officielle"), 9, _hoisted_24)
                                    ]))
                                  }), 128))
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(pendingColors).length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _cache[37] || (_cache[37] = _createElementVNode("p", { class: "text-sm font-medium text-red-700" }, " Couleurs Shopify à lier ", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pendingColors), (pending) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: pending,
                                  class: "flex flex-wrap items-center gap-2 rounded-md border border-red-200 bg-red-50 px-3 py-2"
                                }, [
                                  _createElementVNode("span", _hoisted_26, _toDisplayString(pending), 1),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "text-sm text-red-700 underline hover:text-red-900",
                                    onClick: ($event: any) => (openPendingColorPicker(pending))
                                  }, " Veuillez choisir une couleur officielle ", 8, _hoisted_27)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(form).soldBy === 'melangees')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              (!_unref(form).sizeRangeId)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_29, " Sélectionnez la déclinaison pour saisir les quantités par taille. "))
                                : (_unref(melangeesPackMismatchMessage))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_unref(melangeesPackMismatchMessage)), 1))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_31, " Pour chaque couleur, indiquez la composition du paquet par taille (ex. 1 en S, 2 en M, 1 en L). La somme des couleurs doit correspondre à la quantité du pack. "))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (
              _unref(form).soldBy === 'tailles' &&
              _unref(selectedColors).length > 0 &&
              _unref(selectedSizeNames).length > 0
            )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _cache[38] || (_cache[38] = _createElementVNode("div", null, [
                              _createElementVNode("p", { class: "text-sm font-medium text-gray-800" }, "Stock par taille"),
                              _createElementVNode("p", { class: "text-xs text-gray-500 mt-0.5" }, " Quantités disponibles par couleur et taille (préremplies depuis Shopify si possible). ")
                            ], -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedColors), (color) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: `stock-${color.id}`,
                                class: "flex items-center gap-3 px-3 py-2 border border-gray-200 rounded-md bg-gray-50"
                              }, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("span", {
                                    class: "inline-block w-3 h-3 rounded-full border border-gray-300 flex-shrink-0",
                                    style: _normalizeStyle({
                    backgroundColor: color.hexColor || '#CCCCCC',
                  })
                                  }, null, 4),
                                  _createElementVNode("span", _hoisted_34, _toDisplayString(color.nom), 1)
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(color.tailleStocks || [], (ts, idx) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: `${color.id}-${ts.taille}`,
                                      class: "flex items-center gap-1"
                                    }, [
                                      _createElementVNode("span", _hoisted_36, _toDisplayString(ts.taille), 1),
                                      _createElementVNode("input", {
                                        value: ts.quantity != null ? String(ts.quantity) : '',
                                        type: "number",
                                        min: "0",
                                        class: "w-16 px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500 text-center text-black",
                                        placeholder: "0",
                                        onInput: 
                      (e) =>
                        _unref(setTailleStockQuantity)(
                          color.id,
                          idx,
                          (e.target as HTMLInputElement).value
                        )
                    
                                      }, null, 40, _hoisted_37)
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            }), 128))
                          ]))
                        : (_unref(form).soldBy === 'couleurs' && _unref(selectedColors).length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                              _cache[39] || (_cache[39] = _createElementVNode("div", null, [
                                _createElementVNode("p", { class: "text-sm font-medium text-gray-800" }, "Stock par couleur"),
                                _createElementVNode("p", { class: "text-xs text-gray-500 mt-0.5" }, " Quantités disponibles (préremplies depuis Shopify si possible). ")
                              ], -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedColors), (color) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: `color-stock-${color.id}`,
                                  class: "p-3 border border-gray-200 rounded-md bg-gray-50 flex items-center gap-3"
                                }, [
                                  _createElementVNode("span", {
                                    class: "inline-block w-3 h-3 rounded-full border border-gray-300 flex-shrink-0",
                                    style: _normalizeStyle({ backgroundColor: color.hexColor || '#CCCCCC' })
                                  }, null, 4),
                                  _createElementVNode("span", _hoisted_39, _toDisplayString(color.nom), 1),
                                  _createElementVNode("input", {
                                    value: color.stock != null ? String(color.stock) : '',
                                    type: "number",
                                    min: "0",
                                    class: "w-24 px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500 text-center text-black",
                                    placeholder: "0",
                                    onInput: 
                  (e) =>
                    _unref(setColorStock)(
                      color.id,
                      (e.target as HTMLInputElement).value
                    )
                
                                  }, null, 40, _hoisted_40)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      (_ctx.modelValue)
                        ? (_openBlock(), _createBlock(ShopifyMelPhotosEditor, {
                            key: `shopify-photos-${_ctx.modelValue.id}`,
                            "product-gid": _ctx.modelValue.id,
                            "source-images": _ctx.modelValue.images,
                            "saved-images": _unref(productImageOverrides),
                            "selected-colors": _unref(selectedColors),
                            "color-collisions": _unref(colorCollisions),
                            "color-source-choices": _unref(colorSourceChoices),
                            "linked-source-labels-by-color-id": linkedLabelsWithoutCollisions.value,
                            "onUpdate:images": _unref(onProductImagesUpdate),
                            onSaved: _unref(onProductImagesSaved),
                            onError: emitError
                          }, null, 8, ["product-gid", "source-images", "saved-images", "selected-colors", "color-collisions", "color-source-choices", "linked-source-labels-by-color-id", "onUpdate:images", "onSaved"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      (!_unref(canSaveProductForm))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_43, " Champs obligatoires manquants : " + _toDisplayString(_unref(productFormMissingFields).join(", ")), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_44, [
                        _createVNode(ActionButton, {
                          label: "Annuler",
                          variant: "secondary",
                          type: "button",
                          onClick: _unref(closeProduct)
                        }, null, 8, ["onClick"]),
                        _createVNode(ActionButton, {
                          label: "Enregistrer",
                          variant: "primary",
                          type: "button",
                          loading: _unref(savingProduct),
                          disabled: _unref(savingProduct) || !_unref(canSaveProductForm),
                          onClick: _unref(saveProduct)
                        }, null, 8, ["loading", "disabled", "onClick"])
                      ])
                    ])
                  ], 64))
            ], 32)
          ], 32))
        : _createCommentVNode("", true)
    ])),
    _createVNode(CouleursPickerModal, {
      isVisible: pendingColorModalVisible.value,
      "onUpdate:isVisible": _cache[23] || (_cache[23] = ($event: any) => ((pendingColorModalVisible).value = $event)),
      couleursList: _unref(officialColors),
      "official-only": true,
      selectedIds: collisionPickerSelectedIds.value,
      single: Boolean(collisionColorToAssign.value),
      "disabled-ids": collisionDisabledColorIds.value,
      "linked-source-labels-by-color-id": linkedLabelsWithoutCollisions.value,
      onConfirm: onPendingColorConfirm
    }, null, 8, ["isVisible", "couleursList", "selectedIds", "single", "disabled-ids", "linked-source-labels-by-color-id"]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (pendingCategoryModalVisible.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 z-[10050] flex items-center justify-center p-3 overflow-hidden overscroll-none",
            onClick: _cache[27] || (_cache[27] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("button", {
              class: "absolute inset-0 bg-black/50",
              "aria-label": "Fermer",
              onClick: _cache[24] || (_cache[24] = ($event: any) => (pendingCategoryModalVisible.value = false))
            }),
            _createElementVNode("div", {
              class: "relative bg-white rounded-xl shadow-xl w-full max-w-lg p-5 space-y-4",
              onClick: _cache[26] || (_cache[26] = _withModifiers(() => {}, ["stop"]))
            }, [
              _cache[43] || (_cache[43] = _createElementVNode("h3", { class: "text-base font-semibold text-black" }, " Lier la catégorie Shopify ", -1)),
              _createElementVNode("p", _hoisted_45, [
                _cache[41] || (_cache[41] = _createTextVNode(" « ")),
                _createElementVNode("span", _hoisted_46, _toDisplayString(pendingCategoryToLink.value), 1),
                _cache[42] || (_cache[42] = _createTextVNode(" » → catégorie feuille eFashion "))
              ]),
              _createVNode(CategoryTreeAutocomplete, {
                tree: _unref(categoriesTree),
                "cat-id": "",
                "sous-id": "",
                "sous-sous-id": "",
                label: "Recherche catégorie",
                placeholder: "Rechercher une catégorie feuille…",
                onSelect: onPendingCategorySelect
              }, null, 8, ["tree"]),
              _createElementVNode("div", _hoisted_47, [
                _createVNode(ActionButton, {
                  label: "Annuler",
                  variant: "secondary",
                  size: "sm",
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (pendingCategoryModalVisible.value = false))
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})